module.exports = __webpack_public_path__ + "img/nocollect.586c39db.svg";